"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageObject = exports.ForeignTableEvent = exports.StructureEvent = exports.DocumentEvent = exports.PushEvent = exports.EventType = exports.EventPurpose = void 0;
var EventPurpose;
(function (EventPurpose) {
    EventPurpose[EventPurpose["register"] = 0] = "register";
    EventPurpose[EventPurpose["deregister"] = 1] = "deregister";
    EventPurpose[EventPurpose["push"] = 2] = "push";
})(EventPurpose = exports.EventPurpose || (exports.EventPurpose = {}));
var EventType;
(function (EventType) {
    EventType[EventType["docnew"] = 0] = "docnew";
    EventType[EventType["docnewversion"] = 1] = "docnewversion";
    EventType[EventType["docchanged"] = 2] = "docchanged";
    EventType[EventType["docdeleted"] = 3] = "docdeleted";
    EventType[EventType["docharddeleted"] = 4] = "docharddeleted";
    EventType[EventType["childadded"] = 5] = "childadded";
    EventType[EventType["parentadded"] = 6] = "parentadded";
    EventType[EventType["childremoved"] = 7] = "childremoved";
    EventType[EventType["parentremoved"] = 8] = "parentremoved";
    EventType[EventType["foreigntablechanged"] = 9] = "foreigntablechanged";
})(EventType = exports.EventType || (exports.EventType = {}));
class PushEvent {
    constructor(type, purpose) {
        this.Type = type;
        this.Purpose = purpose;
    }
    static toJSON(pushEvent) {
        return JSON.stringify(pushEvent, (key, value) => {
            if (key === "Type")
                return EventType[value];
            else if (key === "Purpose")
                return EventPurpose[value];
            return value;
        });
    }
    GetHash() {
        return this.Type.toString();
    }
}
exports.PushEvent = PushEvent;
class DocumentEvent extends PushEvent {
    constructor(type, purpose, docid, typeid, etag) {
        super(type, purpose);
        this.TypeId = undefined;
        this.DocId = undefined;
        this.Etag = undefined;
        this.$type = "At.Technodat.Push.DocumentEvent, TdPushClient";
        this.TypeId = typeid;
        this.DocId = docid;
        this.Etag = etag;
    }
    GetHash() {
        var _a;
        return super.GetHash() + "|" + ((_a = this.DocId) === null || _a === void 0 ? void 0 : _a.toString());
    }
    static fromJSON(event) {
        return new DocumentEvent(EventType[event["Type"]], EventPurpose[event["Purpose"]], event["DocId"], event["TypeId"], event["Etag"]);
    }
}
exports.DocumentEvent = DocumentEvent;
class StructureEvent extends PushEvent {
    constructor(type, purpose, parentTypeId, parentDocId, childTypeId, childDocId, structureType) {
        super(type, purpose);
        this.$type = "At.Technodat.Push.StructureEvent, TdPushClient";
        this.parentTypeId = parentTypeId;
        this.parentDocId = parentDocId;
        this.childTypeId = childTypeId;
        this.childDocId = childDocId;
        this.structureType = structureType;
    }
    get ParentTypeId() {
        return this.parentTypeId;
    }
    get ParentDocId() {
        return this.parentDocId;
    }
    get ChildTypeId() {
        return this.childTypeId;
    }
    get ChildDocId() {
        return this.childDocId;
    }
    get StructureType() {
        return this.structureType;
    }
    static fromJSON(event) {
        return new StructureEvent(EventType[event["Type"]], EventPurpose[event["Purpose"]], event["ParentTypeId"], event["ParentDocId"], event["ChildTypeId"], event["ChildDocId"], event["StructureType"]);
    }
    GetHash() {
        var _a;
        let docid;
        switch (this.Type) {
            case EventType.childadded:
            case EventType.childremoved:
                docid = this.parentDocId;
                break;
            case EventType.parentadded:
            case EventType.parentremoved:
                docid = this.childDocId;
                break;
        }
        return super.GetHash() + "|" + (docid === null || docid === void 0 ? void 0 : docid.toString()) + "|" + ((_a = this.structureType) === null || _a === void 0 ? void 0 : _a.toString());
    }
}
exports.StructureEvent = StructureEvent;
class ForeignTableEvent extends PushEvent {
    constructor(type, purpose, name, entries) {
        super(type, purpose);
        this.$type = "At.Technodat.Push.ForeignTableEvent, TdPushClient";
        this.name = name;
        this.entries = entries;
    }
    get Name() {
        return this.name;
    }
    get Entries() {
        return this.entries;
    }
    static fromJSON(event) {
        let ftEvent = new ForeignTableEvent(EventType[event["Type"]], EventPurpose[event["Purpose"]], event["Name"]);
        if (event["Entries"]) {
            ftEvent.entries = [];
            for (let entry of event["Entries"])
                ftEvent.entries.push(entry);
        }
        return ftEvent;
    }
    GetHash() {
        return super.GetHash() + "|" + this.name;
    }
}
exports.ForeignTableEvent = ForeignTableEvent;
class MessageObject {
    constructor(registrationId, event) {
        this.RegistrationId = registrationId;
        this.Event = event;
    }
    static toJSON(pushEvent) {
        return JSON.stringify(pushEvent, (key, value) => {
            if (key === "Type")
                return EventType[value];
            else if (key === "Purpose")
                return EventPurpose[value];
            return value;
        });
    }
    static fromJson(json) {
        let messageObject = Object.assign({}, json);
        let event = undefined;
        switch (json["Event"]["$type"]) {
            case "At.Technodat.Push.DocumentEvent, TdPushClient":
                event = DocumentEvent.fromJSON(messageObject.Event);
                break;
            case "At.Technodat.Push.StructureEvent, TdPushClient":
                event = StructureEvent.fromJSON(messageObject.Event);
                break;
            case "At.Technodat.Push.ForeignTableEvent, TdPushClient":
                event = ForeignTableEvent.fromJSON(messageObject.Event);
                break;
            default:
                throw new Error(json["Event"]["$type"] + " is not supported");
        }
        return new MessageObject(json["RegistrationId"], event);
    }
}
exports.MessageObject = MessageObject;
